// Nombre maximum de règlements de modes différents pour un même encaissement.
export const NOMBRE_REGLEMENTS_MAX = 3;

// Plafond réglementaire d'un règlement en numéraire, en euros.
export const PLAFOND_NUMERAIRE = 300;

// Encaissement direct (LOOC) : valeur du paramètre d'URL `mode` posé par api-regie
// (cf. JetonRepository::generateAppUrl).
export const MODE_ENCAISSEMENT_DIRECT = 'encaissement-direct';

// Intervalle de rafraîchissement automatique des indicateurs (Accueil et Encaissement), en ms.
// N'appelle que l'API régie : l'interrogation MFO garde son propre rythme
// (useInterrogationPaiementsMFO).
export const INTERVALLE_RAFRAICHISSEMENT_INDICATEURS = 60_000;

// En deçà de cet âge (ms), le rafraîchissement automatique ne recharge pas un indicateur : il
// vient de l'être. Aligné sur le cache serveur des endpoints (middleware cache.get:5).
export const FRAICHEUR_MINIMALE_INDICATEURS = 5_000;
